import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../common/utils/logger';

export const onSentimentClick = (
	sentimentClickAttributes: Record<string, string>,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubjectId: 'aiTopic',
			actionSubject:
				sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
			eventType: 'ui',
			attributes: {
				...sentimentClickAttributes,
			},
		};
	} catch (error) {
		logger.error({
			feature: 'knowledge-cards',
			element: 'container',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onSentimentClick',
		});
		return {};
	}
};
